import { MdClose } from "react-icons/md";

/**
 * Muestra el texto del consentimiento informado.
 *
 * El texto viene del backend y admite Markdown básico: ## para títulos y - para
 * viñetas. Se renderiza a mano en lugar de sumar una dependencia por esto.
 */
export default function ModalConsentimiento({
  texto,
  onCerrar,
}: {
  texto: string;
  onCerrar: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onCerrar}
    >
      <div
        className="flex max-h-[85vh] w-full max-w-2xl flex-col rounded-lg bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Consentimiento informado"
      >
        <div className="flex items-center justify-between border-b px-6 py-4">
          <h2 className="text-lg font-bold text-gray-800">
            Consentimiento informado
          </h2>
          <button
            type="button"
            onClick={onCerrar}
            className="text-gray-400 hover:text-gray-600"
            aria-label="Cerrar"
          >
            <MdClose className="h-6 w-6" />
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-4">
          <TextoConsentimiento texto={texto} />
        </div>

        <div className="border-t px-6 py-4 text-right">
          <button
            type="button"
            onClick={onCerrar}
            className="rounded-md bg-brand-500 px-5 py-2 text-sm font-medium text-white hover:bg-brand-600"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

function TextoConsentimiento({ texto }: { texto: string }) {
  const lineas = texto.split("\n");
  const bloques: JSX.Element[] = [];
  let vinetas: string[] = [];

  const volcarVinetas = (clave: number) => {
    if (vinetas.length === 0) return;

    bloques.push(
      <ul
        key={`ul-${clave}`}
        className="mb-3 list-disc space-y-1 pl-5 text-sm text-gray-600"
      >
        {vinetas.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    );
    vinetas = [];
  };

  lineas.forEach((linea, i) => {
    const contenido = linea.trim();

    if (contenido.startsWith("- ")) {
      vinetas.push(contenido.slice(2));
      return;
    }

    volcarVinetas(i);

    if (contenido.startsWith("## ")) {
      bloques.push(
        <h3 key={i} className="mb-2 mt-4 font-semibold text-gray-800">
          {contenido.slice(3)}
        </h3>
      );
    } else if (contenido) {
      bloques.push(
        <p key={i} className="mb-3 text-sm leading-relaxed text-gray-600">
          {contenido}
        </p>
      );
    }
  });

  volcarVinetas(lineas.length);

  return <>{bloques}</>;
}
